import { Tabs, TabsList, TabContent } from "@sembark-travel/ui-base"
import { NavLink } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { Outlet } from "react-router"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function AdminCreditConsumptionLayoutPage() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_ACCOUNTING}>
			<Helmet>
				<title>Credit Consumption</title>
			</Helmet>
			<Tabs>
				<TabsList>
					<NavLink to="all">All</NavLink>
					<NavLink to="mail-parsing">Mail Parsing</NavLink>
					<NavLink to="email-send">Email Send</NavLink>
					<NavLink to="tenants">Tenant-wise</NavLink>
					<NavLink to="ai-parsing">Trip Quote Parsing</NavLink>
					<NavLink to="ai-itinerary-builder">AI Itinerary Builder</NavLink>
				</TabsList>
				<TabContent>
					<Outlet />
				</TabContent>
			</Tabs>
		</ForbidUnlessAuthorized>
	)
}
